import { render } from "./BaseRatesPage.vue?vue&type=template&id=7ff4deb9&scoped=true"
import script from "./BaseRatesPage.vue?vue&type=script&lang=js"
export * from "./BaseRatesPage.vue?vue&type=script&lang=js"

import "./BaseRatesPage.vue?vue&type=style&index=0&id=7ff4deb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff4deb9"]])

export default __exports__